var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-marker',{attrs:{"lat-lng":_vm.getLatLng(_vm.poi.coordinates),"visible":_vm.visible}},[_c('l-icon',{attrs:{"class-name":"map-marker"}},[_c('i',{class:_vm.poi.icon})]),_c('l-popup',[_c('div',[_c('h4',[_vm._v(_vm._s(_vm.poi.name))]),_c('p',[_vm._v(_vm._s(_vm.poi.description))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }